import { ShieldAlert } from 'lucide-react';
import { Button, Card } from '@viana-demos/ui';
import { GODLIKE_ROLE } from '@viana-demos/types';
import { useAuth } from './useAuth';

export function AccessDenied() {
  const { email, logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-viana-grid p-6">
      <Card className="max-w-md p-8 text-center">
        <ShieldAlert className="mx-auto mb-4 h-10 w-10 text-viana-secondary" aria-hidden />
        <h1 className="text-lg font-semibold text-viana-primary">Not available for this account</h1>
        <p className="mt-2 text-sm text-viana-muted">
          Viana Demos is restricted to superadmin accounts. Your account
          {email ? ` (${email})` : ''} does not hold the <code>{GODLIKE_ROLE}</code> realm role.
        </p>
        <Button variant="ghost" className="mt-6" onClick={logout}>
          Sign in as someone else
        </Button>
      </Card>
    </div>
  );
}
